﻿window.cBuilderEmailWidget = function (option) {
    var Me = this;
    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    this.widget = null
    function mConstruit() {

        option.parent = Me
        if (typeof option.element == 'undefined' || option.element == null) {
            //init de l'element vide hors du DOM
            switch (option.typeWidget) {
                case "dxwidgetcolonne": Me.widget = new cBuilderEmailWidgetColonne(option); break;
                case "dxwidgettexte": Me.widget = new cBuilderEmailWidgetTexte(option); break;
                case "dxwidgetvide": Me.widget = new cBuilderEmailWidgetVide(option); break;
                case "dxwidgettitre": Me.widget = new cBuilderEmailWidgetTitre(option); break;
                case "dxwidgetcode": Me.widget = new cBuilderEmailWidgetCode(option); break;
                case "dxwidgetbouton": Me.widget = new cBuilderEmailWidgetBouton(option); break;
                case "dxwidgetimage": Me.widget = new cBuilderEmailWidgetImage(option); break;
                case "dxwidgetseparateur": Me.widget = new cBuilderEmailWidgetSeparateur(option); break;
                case "dxwidgetvideo": Me.widget = new cBuilderEmailWidgetVideo(option); break;
                case "dxwidgetvideoembed": Me.widget = new cBuilderEmailWidgetVideoEmbed(option); break;
                case "dxwidgetreseau": Me.widget = new cBuilderEmailWidgetReseau(option); break;
                case "dxwidgetdesinscription": Me.widget = new cBuilderEmailWidgetDesinscription(option); break;
                case "dxwidgetouvrenavigateur": Me.widget = new cBuilderEmailWidgetOuvreNavigateur(option); break;
                case "dxwidgetvoirdansnavigateur": Me.widget = new cBuilderEmailWidgetVoirDansNavigateur(option); break;
                case "dxwidgetretourtop": Me.widget = new cBuilderEmailWidgetRetourTop(option); break;
                case "dxwidgetmarge": Me.widget = new cBuilderEmailWidgetMarge(option); break;
                case "dxwidgetmenu": Me.widget = new cBuilderEmailWidgetMenu(option); break;
                case "dxwidgetsignature": Me.widget = new cBuilderEmailWidgetSignature(option); break;
                case "dxwidgetperso": Me.widget = new cBuilderEmailWidgetPerso(option); break;
                case "dxwidgetformtextbox": Me.widget = new cBuilderEmailWidgetCtrlTextBox(option); break;
                case "dxwidgetformtextboxnomstr": Me.widget = new cBuilderEmailWidgetCtrlTextBoxNomStr(option); break;
                case "dxwidgetformtextboxnomcon": Me.widget = new cBuilderEmailWidgetCtrlTextBoxNomCon(option); break;
                case "dxwidgetformtextboxprenomcon": Me.widget = new cBuilderEmailWidgetCtrlTextBoxPrenomCon(option); break;
                case "dxwidgetformemail": Me.widget = new cBuilderEmailWidgetCtrlEmail(option); break;
                case "dxwidgetformadrpostale": Me.widget = new cBuilderEmailWidgetCtrlAdrPostale(option); break;
                case "dxwidgetformtel": Me.widget = new cBuilderEmailWidgetCtrlTel(option); break;
                case "dxwidgetformteltel": Me.widget = new cBuilderEmailWidgetCtrlTelTel(option); break;
                case "dxwidgetformtelmob": Me.widget = new cBuilderEmailWidgetCtrlTelMob(option); break;
                case "dxwidgetformtextboxsiteweb": Me.widget = new cBuilderEmailWidgetCtrlWeb(option); break;
                case "dxwidgetformtextarea": Me.widget = new cBuilderEmailWidgetCtrlTextArea(option); break;
                case "dxwidgetformcheckbox": Me.widget = new cBuilderEmailWidgetCtrlCheckBox(option); break;
                case "dxwidgetformdatebox": Me.widget = new cBuilderEmailWidgetCtrlDateBox(option); break;
                case "dxwidgetformnumberbox": Me.widget = new cBuilderEmailWidgetCtrlNumberBox(option); break;
                case "dxwidgetformselect": Me.widget = new cBuilderEmailWidgetCtrlSelect(option); break;
                case "dxwidgetformbtvalide": Me.widget = new cBuilderEmailWidgetCtrlBtValide(option); break;
                case "dxwidgetrgpddesactivepixeltracking": Me.widget = new cBuilderEmailWidgetRGPDDesactivePixelTracking(option); break;
                case "dxwidgetrgpddesinscription": Me.widget = new cBuilderEmailWidgetRGPDDesinscription(option); break;
                case "dxwidgetrgpdnomsociete": Me.widget = new cBuilderEmailWidgetRGPDNomsociete(option); break;
                case "dxwidgetrgpdpolitiqueconf": Me.widget = new cBuilderEmailWidgetRGPDPolitiqueConf(option); break;
                case "dxwidgetrgpdsource": Me.widget = new cBuilderEmailWidgetRGPDSource(option); break;
                case "dxwidgetrgpdtout": Me.widget = new cBuilderEmailWidgetRGPDTout(option); break;
            }
            Me.mCreateElement()
        }
        if (option.element.hasClass("dxwidgetcolonne")) { Me.widget = new cBuilderEmailWidgetColonne(option) }
        else if (option.element.hasClass("dxwidgettexte")) { Me.widget = new cBuilderEmailWidgetTexte(option) }
        else if (option.element.hasClass("dxwidgetvide")) { Me.widget = new cBuilderEmailWidgetVide(option) }
        else if (option.element.hasClass("dxwidgettitre")) { Me.widget = new cBuilderEmailWidgetTitre(option) }
        else if (option.element.hasClass("dxwidgetcode")) { Me.widget = new cBuilderEmailWidgetCode(option) }
        else if (option.element.hasClass("dxwidgetbouton")) { Me.widget = new cBuilderEmailWidgetBouton(option) }
        else if (option.element.hasClass("dxwidgetimage")) { Me.widget = new cBuilderEmailWidgetImage(option) }
        else if (option.element.hasClass("dxwidgetseparateur")) { Me.widget = new cBuilderEmailWidgetSeparateur(option) }
        else if (option.element.hasClass("dxwidgetvideo")) { Me.widget = new cBuilderEmailWidgetVideo(option) }
        else if (option.element.hasClass("dxwidgetvideoembed")) { Me.widget = new cBuilderEmailWidgetVideoEmbed(option) }
        else if (option.element.hasClass("dxwidgetreseau")) { Me.widget = new cBuilderEmailWidgetReseau(option) }
        else if (option.element.hasClass("dxwidgetdesinscription")) { Me.widget = new cBuilderEmailWidgetDesinscription(option) }
        else if (option.element.hasClass("dxwidgetouvrenavigateur")) { Me.widget = new cBuilderEmailWidgetOuvreNavigateur(option) }
        else if (option.element.hasClass("dxwidgetvoirdansnavigateur")) { Me.widget = new cBuilderEmailWidgetVoirDansNavigateur(option) }
        else if (option.element.hasClass("dxwidgetretourtop")) { Me.widget = new cBuilderEmailWidgetRetourTop(option) }
        else if (option.element.hasClass("dxwidgetmarge")) { Me.widget = new cBuilderEmailWidgetMarge(option) }
        else if (option.element.hasClass("dxwidgetmenu")) { Me.widget = new cBuilderEmailWidgetMenu(option) }
        else if (option.element.hasClass("dxwidgetsignature")) { Me.widget = new cBuilderEmailWidgetSignature(option) }
        else if (option.element.hasClass("dxwidgetperso")) { Me.widget = new cBuilderEmailWidgetPerso(option) }
        else if (option.element.hasClass("dxwidgetrgpddesactivepixeltracking")) { Me.widget = new cBuilderEmailWidgetRGPDDesactivePixelTracking(option) }
        else if (option.element.hasClass("dxwidgetrgpddesinscription")) { Me.widget = new cBuilderEmailWidgetRGPDDesinscription(option) }
        else if (option.element.hasClass("dxwidgetrgpdnomsociete")) { Me.widget = new cBuilderEmailWidgetRGPDNomsociete(option) }
        else if (option.element.hasClass("dxwidgetrgpdpolitiqueconf")) { Me.widget = new cBuilderEmailWidgetRGPDPolitiqueConf(option) }
        else if (option.element.hasClass("dxwidgetrgpdsource")) { Me.widget = new cBuilderEmailWidgetRGPDSource(option) }
        else if (option.element.hasClass("dxwidgetrgpdtout")) { Me.widget = new cBuilderEmailWidgetRGPDTout(option) }
        else if (option.element.hasClass("widgetdevexpress")) {
            Me.widget = new window[option.element.attr("classwidget")](option)
        }
        //else if (option.element.hasClass("dxwidgetformtextbox")) { Me.widget = new cBuilderEmailWidgetCtrlTextBox(option) }
        //else if (option.element.hasClass("dxwidgetformtextboxnomstr")) { Me.widget = new cBuilderEmailWidgetCtrlTextBoxNomStr(option) }
        //else if (option.element.hasClass("dxwidgetformtextboxprenomcon")) { Me.widget = new cBuilderEmailWidgetCtrlTextBoxPrenomCon(option) }
        //else if (option.element.hasClass("dxwidgetformtextboxnomcon")) { Me.widget = new cBuilderEmailWidgetCtrlTextBoxNomCon(option) }
    }

    this.mCreateElement = function () {
        this.widget.mCreateElement()
        if (typeof this.mGetBodyWidget().attr("jsoncssdatabloc") == "undefined") this.mGetBodyWidget().attr("jsoncssdatabloc", JSON.stringify({}))
        if (typeof this.mGetBodyWidget().attr("jsoncssdatablocinner") == "undefined") this.mGetBodyWidget().attr("jsoncssdatablocinner", JSON.stringify({}))
    }

    this.mGetBodyWidget = function () { return $(option.element.find(".bodywidget")[0]) }
    this.mGetPaddingBordureWidget = function () { return $(option.element.find(".tdpaddingborderwidget")[0]) }
    this.mGetContenuWidget = function () { return $(option.element.find(".contenuwidget")[0]) }
    this.mGetTotalWidthPaddingEtBorder = function () {
        return this.mGetBodyWidget().css("padding-right").replace("px", "") * 1 + this.mGetBodyWidget().css("padding-left").replace("px", "") * 1 + this.mGetBodyWidget().css("border-width").replace("px", "") * 2
    }

    this.getCurrentEditorHtml = function () {
        if (typeof this.widget.getCurrentEditorHtml == "undefined") { return null }
        else { return this.widget.getCurrentEditorHtml() }
    }

    this.mRempliSaisie = function (contentElement) {

        var dxScroll = $("<div/>").appendTo(contentElement).dxScrollView({}).dxScrollView("instance")
        if (option.element.hasClass("dxwidgetvide")) {
            var $Div = $("<div style='padding:15px;text-align:center;'/>").appendTo(dxScroll.content())
            var $A = $("<a href='javascript:void(0)'>Sélectionner le groupe de colonne</a>").appendTo($Div)
            $A.on("click", function (e) {
                option.dxBuilderEmailPage.mSelectWidget($(Me.mGetBodyWidget().closest(".dxwidgetcolonne")[0]))
            })
        } else {

            if (!option.element.hasClass("dxwidgetcolonne") && option.element.closest(".dxwidgetcolonne").length > 0) {
                var $Div = $("<div style='padding:15px;text-align:center;'/>").appendTo(dxScroll.content())
                var $A = $("<a href='javascript:void(0)'>Sélectionner le groupe de colonne</a>").appendTo($Div)
                $A.on("click", function (e) {
                    option.dxBuilderEmailPage.mSelectWidget($(option.element.closest(".dxwidgetcolonne")[0]))
                })
            }

            var ds = []
            var selectedIds = null
            if (typeof Me.widget.mAddCtrlSaisie != 'undefined') {
                ds.push({ id: 0, text: "Contenu" })
                selectedIds = 0
            }
            if (typeof Me.widget.mAddCtrlStyle != 'undefined') {
                ds.push({ id: 1, text: "Style widget" })
                if (typeof Me.widget.mAddCtrlSaisie == 'undefined') selectedIds = 1
            }
            ds.push({ id: 2, text: "Style bloc widget" })
            if (selectedIds == null) selectedIds = 2

            ds.forEach(function (itemData) {
                var $DivTitle = $("<div style='padding:10px;background-color:" + theme.backgroundcolorTooltip + "'/>").appendTo(dxScroll.content())
                var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo($DivTitle)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%;font-size:180%;font-weight:Bold;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'>" + itemData.text + "</td>").appendTo($Tr)

                if (itemData.id == 0) {
                    $Td.prepend("<span><i class='" + Me.widget.icone + "'></i> </span>")
                    $("<span style='font-size:70%;'> (" + (Me.widget.nom ? Me.widget.nom : "Saisie/" + Me.widget.nomBt) + ")</span>").appendTo($Td)
                } else {
                    var $Td = $("<td style='width:" + (HeightButton - 20) + "px;'></td>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        icon: 'fas fa-text-slash',
                        width: HeightButton - 20,
                        height: HeightButton - 20,
                        txtTooltip: "Rétablir<br/>les styles initiaux",
                        onClick: function (e) {
                            e.event.stopPropagation()
                            switch (itemData.id) {
                                case 1:
                                    Me.widget.mRemoveStyle();
                                    if (typeof itemData.itemElement != 'undefined') {
                                        itemData.itemElement.css("height", ((itemData.itemElement.innerHeight() > 0) ? itemData.itemElement.innerHeight() + "px" : ""))
                                        Me.widget.mAddCtrlStyle(itemData.itemElement);
                                        itemData.itemElement.css("height", "")
                                    }
                                    break;
                                case 2:
                                    mRemoveStyleBloc();
                                    if (typeof itemData.itemElement != 'undefined') {
                                        itemData.itemElement.css("height", ((itemData.itemElement.innerHeight() > 0) ? itemData.itemElement.innerHeight() + "px" : ""))
                                        mAddCtrlStyleBloc(itemData.itemElement);
                                        itemData.itemElement.css("height", "")
                                    }
                                    break;
                            }
                        }
                    })
                }

                var $DivElement = $("<div/>").appendTo(dxScroll.content())
                $DivElement.css("padding", "20px")
                switch (itemData.id) {
                    case 0: Me.widget.mAddCtrlSaisie($DivElement); break; //page
                    case 1: Me.widget.mAddCtrlStyle($DivElement); break; //Text
                    case 2: mAddCtrlStyleBloc($DivElement); break; //Text
                }
            })
            //var dxAccord = $("<div/>").appendTo(dxScroll.content()).dxCtrlAccordion({
            //    stickyTitle: true,
            //    dataSource: ds,
            //    selectedIds: [selectedIds],
            //    multiple: false,
            //    itemClosed: function () {
            //        dxAccord.element().find(".dx-accordion-item-title").css("background-color", theme.backgroundcolorSelectOpacity1)
            //    },
            //    itemOpened: function () {
            //        dxAccord.element().find(".dx-accordion-item-title").css("background-color", theme.backgroundcolorSelectOpacity1)
            //    },
            //    itemTitleTemplate: function (itemData, itemIndex, itemElement) {
            //        itemElement.css("color", theme.backgroundcolorAccent)
            //        if (itemIndex == 0) itemElement.css("border-top", "")
            //        var $Table = $("<table style='width:92%;table-layout:fixed;'/>").appendTo(itemElement)
            //        var $Tr = $("<tr/>").appendTo($Table)
            //        var $Td = $("<td style='width:100%;font-size:180%;font-weight:Bold;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'>" + itemData.text + "</td>").appendTo($Tr)

            //        if (itemData.id == 0) {
            //            $Td.prepend("<span><i class='" + Me.widget.icone + "'></i> </span>")
            //            $("<span style='font-size:70%;'> (" + (Me.widget.nom ? Me.widget.nom : "Saisie/" + Me.widget.nomBt) + ")</span>").appendTo($Td)
            //        } else {
            //            var $Td = $("<td style='width:" + (HeightButton - 20) + "px;'></td>").appendTo($Tr)
            //            $("<div/>").appendTo($Td).dxCtrlButton({
            //                icon: 'fas fa-text-slash',
            //                width: HeightButton - 20,
            //                height: HeightButton - 20,
            //                txtTooltip: "Rétablir<br/>les styles initiaux",
            //                onClick: function (e) {
            //                    e.event.stopPropagation()
            //                    switch (itemData.id) {
            //                        case 1:
            //                            Me.widget.mRemoveStyle();
            //                            if (typeof itemData.itemElement != 'undefined') {
            //                                itemData.itemElement.css("height", ((itemData.itemElement.innerHeight() > 0) ? itemData.itemElement.innerHeight() + "px" : ""))
            //                                Me.widget.mAddCtrlStyle(itemData.itemElement);
            //                                itemData.itemElement.css("height", "")
            //                            }
            //                            break;
            //                        case 2:
            //                            mRemoveStyleBloc();
            //                            if (typeof itemData.itemElement != 'undefined') {
            //                                itemData.itemElement.css("height", ((itemData.itemElement.innerHeight() > 0) ? itemData.itemElement.innerHeight() + "px" : ""))
            //                                mAddCtrlStyleBloc(itemData.itemElement);
            //                                itemData.itemElement.css("height", "")
            //                            }
            //                            break;
            //                    }
            //                }
            //            })
            //        }
            //    },
            //    itemTemplate: function (itemData, itemIndex, itemElement) {
            //        itemData.itemElement = itemElement
            //        //itemElement.css("padding", "0 30px 30px 30px")
            //        itemElement.css("padding", "20px")
            //        switch (itemData.id) {
            //            case 0: Me.widget.mAddCtrlSaisie(itemElement); break; //page
            //            case 1: Me.widget.mAddCtrlStyle(itemElement); break; //Text
            //            case 2: mAddCtrlStyleBloc(itemElement); break; //Text
            //        }
            //    },
            //    onContentReady: function (e) {
            //        e.element.find(".dx-accordion-item-title").css("overflow", "hidden")
            //        e.element.find(".dx-accordion-item-title").css("background-color", theme.backgroundcolorSelectOpacity1)
            //        //e.element.find(".dx-accordion-item-title").css("border", "none")
            //    }
            //}).dxCtrlAccordion("instance")
        }

        return dxScroll
    }

    function mAddCtrlStyleBloc(contentElement) {
        contentElement.empty()

        var jsonCssDataBlocOriginalValue = JSON.parse(Me.mGetBodyWidget().attr("jsoncssdatabloc"))
        var jsonCssDataBloc = {}
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("blocwidget")) {
            jsonCssDataBloc[prop] = ""
            if (typeof jsonCssDataBlocOriginalValue[prop] != 'undefined') jsonCssDataBloc[prop] = jsonCssDataBlocOriginalValue[prop]
        }

        var jsonCssDataBlocInnerOriginalValue = JSON.parse(Me.mGetBodyWidget().attr("jsoncssdatablocinner"))
        var jsonCssDataBlocInner = {}
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("blocwidgetinner")) {
            jsonCssDataBlocInner[prop] = ""
            if (typeof jsonCssDataBlocInnerOriginalValue[prop] != 'undefined') jsonCssDataBlocInner[prop] = jsonCssDataBlocInnerOriginalValue[prop]
        }
        $("<div/>").appendTo(contentElement).dxCtrlBuilderEmailStyleBloc({
            showAlign: true,//!option.element.hasClass("dxwidgetcolonne2"),
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            blocwidget: jsonCssDataBloc,
            blocwidgetinner: jsonCssDataBlocInner,
            allowDefaut: true,
            onValueChanged: function (e) {
                if (typeof e.values != 'undefined') e.values.forEach(function (value) {
                    if (value.value.length > 0) { jsonCssDataBlocOriginalValue[value.prop] = value.value }
                    else { delete jsonCssDataBlocOriginalValue[value.prop] }
                })
                Me.mGetBodyWidget().attr("jsoncssdatabloc", JSON.stringify(jsonCssDataBlocOriginalValue))

                if (typeof e.values_inner != 'undefined') e.values_inner.forEach(function (value) {
                    if (value.value.length > 0) { jsonCssDataBlocInnerOriginalValue[value.prop] = value.value }
                    else { delete jsonCssDataBlocInnerOriginalValue[value.prop] }
                })
                Me.mGetBodyWidget().attr("jsoncssdatablocinner", JSON.stringify(jsonCssDataBlocInnerOriginalValue))
                option.onValueChanged()
            }
        })
    }

    this.mGetTextAlignCss = function () {
        if (typeof Me.mGetBodyWidget() == 'undefined' || typeof Me.mGetBodyWidget().attr("jsoncssdatabloc") == 'undefined') {
            //on est entrain de créer le bloc
            return option.dxBuilderEmailPage.mJsonCssGuideProperty("blocwidget", "text-align")
        } else {
            var jsonCssData = JSON.parse(Me.mGetBodyWidget().attr("jsoncssdatabloc"))
            if (typeof jsonCssData["text-align"] != 'undefined' && jsonCssData["text-align"].length > 0) {
                return jsonCssData["text-align"]
            } else {
                return option.dxBuilderEmailPage.mJsonCssGuideProperty("blocwidget", "text-align")
            }
        }
    }
    this.mGetTotalWidthPaddingEtBorder = function () {
        var padLeft = Me.mGetBodyWidget().css("padding-left").replace("px", "")
        var padRight = Me.mGetBodyWidget().css("padding-right").replace("px", "")
        var borderLeftWidth = Me.mGetBodyWidget().css("border-left-width").replace("px", "")
        var borderRightWidth = Me.mGetBodyWidget().css("border-right-width").replace("px", "")
        var tot = parseInt(padLeft) + parseInt(padRight) + parseInt(borderLeftWidth) + parseInt(borderRightWidth)
        return tot
    }
    this.mGetTotalWidthContainerWithoutPaddingBorder = function () {
        var tot = this.mGetTotalWidthPaddingEtBorder()

        var widthContainer = option.dxBuilderEmailPage.mGetWidthPage()
        if (Me.mGetBodyWidget().parent().closest(".dxwidgetcolonne").length > 0) {
            var widgetCol = new cBuilderEmailWidget({
                bddCtrl: option.bddCtrl,
                dxBuilderEmailPage: option.dxBuilderEmailPage,
                element: $(Me.mGetBodyWidget().parent().closest(".dxwidgetcolonne")[0])
            })
            var idCol = Me.mGetBodyWidget().parent().closest(".colonne").attr("numcol")
            widthContainer = widgetCol.widget.mGetInnerWidthColonne(idCol)
        }
        return widthContainer - tot
    }

    function mRemoveStyleBloc() {
        var jsonCssData = JSON.parse(Me.mGetBodyWidget().attr("jsoncssdatabloc"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("blocwidget")) {
            delete jsonCssData[prop]
        }
        Me.mGetBodyWidget().attr("jsoncssdatabloc", JSON.stringify(jsonCssData))

        option.onValueChanged()
    }

    this.mUpdateCss = function () {
        if (option.element.hasClass("dxwidgetvide")) return
        var jsonCssData = JSON.parse(Me.mGetBodyWidget().attr("jsoncssdatabloc"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("blocwidget")) {
            if (typeof jsonCssData[prop] != 'undefined' && jsonCssData[prop].length > 0) {
                Me.mGetBodyWidget().css(prop, jsonCssData[prop])
            } else {
                Me.mGetBodyWidget().css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty("blocwidget", prop))
            }
            //if (prop == "text-align") {
            //    //pour la propriété
            if (typeof jsonCssData[prop] != 'undefined' && jsonCssData[prop].length > 0) {
                Me.mGetBodyWidget().find("td").css(prop, jsonCssData[prop])
            } else {
                Me.mGetBodyWidget().find("td").css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty("blocwidget", prop))
            }
            //}
        }
        var jsonCssDataInner = JSON.parse(Me.mGetBodyWidget().attr("jsoncssdatablocinner"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty("blocwidgetinner")) {
            if (typeof jsonCssDataInner[prop] != 'undefined' && jsonCssDataInner[prop].length > 0) {
                Me.mGetPaddingBordureWidget().css(prop, jsonCssDataInner[prop])
            } else {
                Me.mGetPaddingBordureWidget().css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty("blocwidgetinner", prop))
            }
        }
        Me.widget.mUpdateCss()
    }

    this.element = function () { return container }

    mConstruit();
}